import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { Suspense, useContext, useEffect, useMemo, useRef } from "react";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { styled } from "@mui/material/styles";
import {
	GENERAL_TO_VEB_COVERAGE_CODE,
	VEBToGeneralCoverageCodeType,
	VEB_TO_GENERAL_COVERAGE_CODE
} from "../../../../../../../constants/coverage";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { INSUARANCEPRIMIER } from "../../../../../../../constants/insuarancePremier";
import { AGERANGE } from "../../../../../../../constants/ageRange";
import { BENEFITAMOUNT } from "../../../../../../../constants/benefitAmount";
import {
	Enrollment,
	EnrollmentCommonDetails,
	EnrollmentStandardDetails,
	VEBEnrollments,
	VEBEnrollmentSchema,
	VEBEnrollmentStandardDetails
} from "../../../../../../../types/enrollment.types";
import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";

import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";

import "./criticalIllness.css";
import { CriticalIllnessPremium } from "../../../../../../../types/criticalIllnessPrimium.types";
import {
	CriticalIllnessAgeGroups,
	CriticalIllnessBenefitLevel,
	CriticalIllnessCoverageLevel,
	CriticalIllnessPlanCoverage,
	CriticalIllnessPlanDetails,
	PaycheckFrequency,
	VEBPlan
} from "../../../../../../../types/plan.types";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import { getCriticalIllnessPremium } from "../../../../../../../utils/commonFunctions/plan";
import calculateAge from "../../../../../../../utils/commonFunctions/age";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import Typography from "@mui/material/Typography";
import { useHistory, useLocation } from "react-router-dom";
import {
	generateActivateVEBEnrollmentPayload,
	generateCancerKemperWaiveEnrollmentPayload,
	generateCriticalIllnessWaiveEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import {
	getKemperCancerEligibleDependents,
	getKemperCriticalIllnessEligibleDependents
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import EnrollmentDependencyDialog from "../dependencyDialog/EnrollmentDependencyDialog";
import { DEPENDENCY_MESSAGE } from "../../../../../../../constants/VEB/dependencyMessage";
import VEBPlanCard from "../../../../../../shared/VEBPlanCard/VEBPlanCard";
import { AddBeneficiary, Beneficiary } from "../../../../../../../types/addBeneficiary.types";
import VEBModal from "../../../../../../shared/VEBModal/VEBModal";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import { CRITICAL_ILLNESS_PREMIUM } from "../../../../../../../constants/vebPremiums/VEBPremiums";
import { calculateAgeGroup } from "../../../../../../../utils/commonFunctions/calculateAge";
import { BV2Beneficiery } from "../../../../../../../types/BV2Beneficiery.types";
import VEBBeneficiary from "../../../../VEBBeneficiary/VEBBeneficiary";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import ExistsDependentModelVEB from "../../../../../../shared/existsMemberModel/ExistsDependentModelVEB";

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
	({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		"&:not(:last-child)": {
			borderBottom: 0
		},
		"&:before": {
			display: "none"
		}
	})
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)"
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1)
	}
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)"
}));

const KemperCriticalIllnessForm = ({ VEBOpenEnrollment, getVEBEnrollmentInitData }: VEBPlanFormProps): JSX.Element => {
	const [waiveReason, setWaiveReason] = useState("");
	const location = useLocation();
	const history = useHistory();
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Critical Illness"
	});
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [writingNumber, setWritingNumber] = useState(1408);
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [expanded_panel, setExpandedPanel] = useState<string | false>("panel_beneficiary");
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const [addMemberPrimaryBeneficiary, setAddMemberPrimaryBeneficiary] = useState<AddBeneficiary>([]);
	const [addSpousePrimaryBeneficiary, setAddSpousePrimaryBeneficiary] = useState<AddBeneficiary>([]);
	const [addMemberContigentBeneficiary, setAddMemberContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [addSpouseContigentBeneficiary, setAddSpouseContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [primaryMemberBeneficiary, setPrimaryMemberBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [contingentMemberBeneficiary, setContingentMemberBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [primarySpouseBeneficiary, setPrimarySpouseBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [contingentSpouseBeneficiary, setContingentSpouseBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [selectCard, setSelectCard] = useState<string>("");
	const [modalOpen, setModalOpen] = useState(false);
	const [editData, setEditData] = useState<null | Beneficiary>(null);
	const [enrollmentDependencyDialogProps, setEnrollmentDependencyDialogProps] = useState({
		openDialog: false,
		content: DEPENDENCY_MESSAGE.critical_illness,
		actions: [
			{
				label: "Proceed without Without Cancer coverage level",
				name: "cancel",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
				}
			},
			{
				label: "Waive Cancer Plan",
				name: "Waive Cancer Plan",
				callback: () => {
					setEnrollmentDependencyDialogProps(
						Object.assign({}, enrollmentDependencyDialogProps, { openDialog: false })
					);
					history.push("?step=Cancer&stage=1&from=Critical Illness");
				}
			}
		]
	});
	const [criticalIllnessPlanDetails, setCriticalIllnessPlanDetails] = useState<CriticalIllnessPlanDetails>({
		benefit_amount: [10000, 20000, 30000],
		coverage: ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"],
		coverage_level: ["Without Cancer"],
		premium_amount: {
			standard_premium: {
				"Employee Only": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 0.66,
								MONTHLY: 2.86
							},
							"40-59": {
								WEEKLY: 3.03,
								MONTHLY: 13.13
							},
							"60-64": {
								WEEKLY: 5.13,
								MONTHLY: 22.23
							},
							"65+": {
								WEEKLY: 8.47,
								MONTHLY: 36.7
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 1.03,
								MONTHLY: 4.46
							},
							"40-59": {
								WEEKLY: 5.71,
								MONTHLY: 24.74
							},
							"60-64": {
								WEEKLY: 9.92,
								MONTHLY: 42.99
							},
							"65+": {
								WEEKLY: 16.59,
								MONTHLY: 71.89
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 1.4,
								MONTHLY: 6.07
							},
							"40-59": {
								WEEKLY: 8.4,
								MONTHLY: 36.4
							},
							"60-64": {
								WEEKLY: 14.71,
								MONTHLY: 63.74
							},
							"65+": {
								WEEKLY: 24.71,
								MONTHLY: 107.08
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.12,
								MONTHLY: 4.85
							},
							"40-59": {
								WEEKLY: 5.71,
								MONTHLY: 24.74
							},
							"60-64": {
								WEEKLY: 9.75,
								MONTHLY: 42.25
							},
							"65+": {
								WEEKLY: 15.05,
								MONTHLY: 65.22
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 1.94,
								MONTHLY: 8.41
							},
							"40-59": {
								WEEKLY: 11.07,
								MONTHLY: 47.97
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 29.75,
								MONTHLY: 128.92
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 2.77,
								MONTHLY: 12
							},
							"40-59": {
								WEEKLY: 16.44,
								MONTHLY: 71.24
							},
							"60-64": {
								WEEKLY: 28.57,
								MONTHLY: 123.8
							},
							"65+": {
								WEEKLY: 44.46,
								MONTHLY: 192.66
							}
						}
					}
				},
				"Employee & Family": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				},
				"Employee & Children": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				},
				"Employee & Spouse": {
					"Without Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 1.52,
								MONTHLY: 6.59
							},
							"40-59": {
								WEEKLY: 6.17,
								MONTHLY: 26.74
							},
							"60-64": {
								WEEKLY: 10.3,
								MONTHLY: 44.63
							},
							"65+": {
								WEEKLY: 16.03,
								MONTHLY: 69.46
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 2.31,
								MONTHLY: 10.01
							},
							"40-59": {
								WEEKLY: 11.52,
								MONTHLY: 49.92
							},
							"60-64": {
								WEEKLY: 19.77,
								MONTHLY: 85.67
							},
							"65+": {
								WEEKLY: 31.22,
								MONTHLY: 135.29
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 3.1,
								MONTHLY: 13.43
							},
							"40-59": {
								WEEKLY: 16.86,
								MONTHLY: 73.06
							},
							"60-64": {
								WEEKLY: 29.24,
								MONTHLY: 126.71
							},
							"65+": {
								WEEKLY: 46.42,
								MONTHLY: 201.15
							}
						}
					},
					"With Cancer": {
						10000.0: {
							"18-39": {
								WEEKLY: 2.46,
								MONTHLY: 10.66
							},
							"40-59": {
								WEEKLY: 11.15,
								MONTHLY: 48.32
							},
							"60-64": {
								WEEKLY: 19.16,
								MONTHLY: 83.03
							},
							"65+": {
								WEEKLY: 28.37,
								MONTHLY: 122.94
							}
						},
						20000.0: {
							"18-39": {
								WEEKLY: 4.18,
								MONTHLY: 18.11
							},
							"40-59": {
								WEEKLY: 21.47,
								MONTHLY: 93.04
							},
							"60-64": {
								WEEKLY: 37.48,
								MONTHLY: 162.41
							},
							"65+": {
								WEEKLY: 55.9,
								MONTHLY: 242.23
							}
						},
						30000.0: {
							"18-39": {
								WEEKLY: 5.91,
								MONTHLY: 25.61
							},
							"40-59": {
								WEEKLY: 31.79,
								MONTHLY: 137.76
							},
							"60-64": {
								WEEKLY: 55.81,
								MONTHLY: 241.84
							},
							"65+": {
								WEEKLY: 83.44,
								MONTHLY: 361.57
							}
						}
					}
				}
			}
		}
	});
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const [standardPremium, setStandardPremium] = useState(0.0);
	const [hasCancerEnrollment, setHasCancerEnrollment] = useState<null | boolean>(null);
	const [criticalIllnessPlanInputs, setCriticalIllnessPlanInputs] = useState<{
		coverage: null | string;
		coverage_level: null | "With Cancer" | "Without Cancer";
		benefit_amount: null | number;
	}>({
		coverage: null,
		coverage_level: null,
		benefit_amount: null
	});
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [criticalIllnessPlan, setCriticalIllnessPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const { theme } = useContext(ThemeContext);
	const [spouse, setSpouse] = useState<Member>();
	const { member } = useContext(AuthContext);
	const { dependents } = useContext(DependentsContext);
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const { paycheck } = useContext(PaycheckContext);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const { groupOwner } = useContext(GroupOwnerContext);

	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Critical Illness: I hereby apply to Reserve National Insurance Company for insurance coverage to be issued solely and entirely in reliance upon the written answers to the foregoing questions and/or information obtained by the Company in its underwriting process. I agree and understand that no insurance coverage will be in force until the effective date specified by the Company. I represent that no person to be covered under the terms of the certificate being applied for is also covered by Medicaid or any similar program. I have read or had read to me all the questions and answers in this application and such answers to the best of my (our) knowledge and belief are true and complete. I understand and agree that any falsity of any answer or statement in this application which materially affects the acceptance of the risk or hazard assumed by the Company may bar the right to recovery under any certificate issued. FRAUD WARNING:Any person who, with intent to defraud or knowing that he/she is facilitating a fraud against an insurer,submits an application or files a claim containing a false or deceptive statement may be guilty ofinsurance fraud.",
			importantTitle: "IMPORTANT",
			importantContent:
				"If an individual is insured under this policy and is also covered by Medicaid or a state variation of Medicaid, most non-disability benefits are automatically assigned according to state regulations.  This means that instead of paying the benefits to the insured individual, we must pay the benefits to Medicaid or the medical provider to reduce the charges billed to Medicaid.  Please consider your circumstances before enrolling in MedMutual Protect Benefits coverage.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	//BV2 State
	const [BV2employeePrimaryBeneficiary, setBV2EmployeePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2employeeContingentBeneficiary, setBV2EmployeeContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spousePrimaryBeneficiary, setBV2SpousePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spouseContingentBeneficiary, setBV2SpouseContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childPrimaryBeneficiary, setBV2ChildPrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childContingentBeneficiary, setBV2ChildContingentBeneficiary] = useState<BV2Beneficiery[]>([]);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.critical_illness) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setCriticalIllnessPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
		let sum = 0,
			i;
		for (i = 0; i < beneficiary.length; i++) {
			const { percentage } = beneficiary[i];
			sum += percentage;
		}
		return sum;
	}, []);

	const handleBeneficiaryValidate = useCallback(() => {
		let isValid = true;
		if (
			criticalIllnessPlanInputs.coverage === "Employee Only" ||
			criticalIllnessPlanInputs.coverage === "Employee & Spouse" ||
			criticalIllnessPlanInputs.coverage === "Employee & Children" ||
			criticalIllnessPlanInputs.coverage === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2employeePrimaryBeneficiary.length === 0) {
				alert("Employee must have alteast One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2employeePrimaryBeneficiary.length > 4) {
				alert("Employee can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const employeePrimaryPercentageSum = validateBeneficiary(BV2employeePrimaryBeneficiary, "PRIMARY");
			if (employeePrimaryPercentageSum !== 100 && employeePrimaryPercentageSum !== 0) {
				alert("Primary Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2employeeContingentBeneficiary.length !== 0) {
				if (BV2employeeContingentBeneficiary.length !== 1) {
					alert("Employee can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}

			const employeeContingentPercentageSum = validateBeneficiary(BV2employeeContingentBeneficiary, "CONTINGENT");
			if (employeeContingentPercentageSum !== 100 && employeeContingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
		if (
			criticalIllnessPlanInputs.coverage === "Spouse Only" ||
			criticalIllnessPlanInputs.coverage === "Employee & Spouse" ||
			criticalIllnessPlanInputs.coverage === "Spouse & Children" ||
			criticalIllnessPlanInputs.coverage === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2spousePrimaryBeneficiary.length === 0) {
				alert("Spouse must have alteast one Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2spousePrimaryBeneficiary.length !== 1) {
				alert("Spouse can have only One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			const spousePrimaryPercentageSum = validateBeneficiary(BV2spousePrimaryBeneficiary, "PRIMARY");
			if (spousePrimaryPercentageSum !== 100 && spousePrimaryPercentageSum !== 0) {
				alert("Spouse Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2spouseContingentBeneficiary.length !== 0) {
				if (BV2spouseContingentBeneficiary.length !== 1) {
					alert("Spouse can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}

			const contingentPercentageSum = validateBeneficiary(BV2spouseContingentBeneficiary, "CONTINGENT");
			if (contingentPercentageSum !== 100 && contingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
		if (
			criticalIllnessPlanInputs.coverage === "Employee & Children" ||
			criticalIllnessPlanInputs.coverage === "Spouse & Children" ||
			criticalIllnessPlanInputs.coverage === "Employee & Family"
		) {
			// Primary Beneficiary
			if (BV2childPrimaryBeneficiary.length === 0) {
				alert("Child can have alteddast One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2childPrimaryBeneficiary.length !== 1) {
				alert("Child can have only One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			const childPrimaryPercentageSum = validateBeneficiary(BV2childPrimaryBeneficiary, "PRIMARY");
			if (childPrimaryPercentageSum !== 100 && childPrimaryPercentageSum !== 0) {
				alert("Child Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2childContingentBeneficiary.length !== 0) {
				if (BV2childContingentBeneficiary.length !== 1) {
					alert("Child can have only One Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}
			}

			const childContingentPercentageSum = validateBeneficiary(BV2childContingentBeneficiary, "CONTINGENT");
			if (childContingentPercentageSum !== 100 && childContingentPercentageSum !== 0) {
				alert("Contingent Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}
		}
	}, [
		BV2childContingentBeneficiary,
		BV2childPrimaryBeneficiary,
		BV2employeeContingentBeneficiary,
		BV2employeePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		BV2spousePrimaryBeneficiary,
		criticalIllnessPlanInputs.coverage,
		validateBeneficiary
	]);

	//End BV2 State

	const handleAddBeneficiaryDetails = useCallback(
		(eventName: string, beneficiaryAllDetails: any) => {
			if (member && eventName === "member-card-estate") {
				if ([...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].length === 0) {
					const newBeneficiary: Beneficiary = {
						first_name: member?.first_name,
						last_name: member?.last_name,
						type: "PRIMARY",
						enrollment_id: member?._id,
						insured_SSN: member?.SSN,
						relation: member.relationship,
						address_line_1: member.address_line_1,
						address_line_2: member?.address_line_2,
						state: member?.state,
						ZIP: member?.ZIP,
						SSN: member?.SSN,
						date_of_birth: new Date(member?.date_of_birth === undefined ? "" : member?.date_of_birth),
						gender: member.gender,
						percentage: 100,
						phone_number: member.phone_number,
						canEdit: false
					};
					setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
					setSelectCard("member-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "member-card-spouse") {
				if ([...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].length === 0) {
					const spouseDetails = dependents.filter((val: any, index: number) => {
						if (val.relationship === "SPOUSE") {
							return true;
						} else {
							return false;
						}
					})[0];
					const newBeneficiary: Beneficiary = {
						first_name: spouseDetails?.first_name,
						last_name: spouseDetails?.last_name,
						type: "PRIMARY",
						enrollment_id: spouseDetails?._id,
						insured_SSN: spouseDetails?.SSN,
						relation: spouseDetails?.relationship,
						address_line_1: spouseDetails?.address_line_1,
						address_line_2: spouseDetails?.address_line_2,
						state: spouseDetails?.state,
						ZIP: spouseDetails?.ZIP,
						SSN: spouseDetails?.SSN,
						date_of_birth: spouseDetails?.date_of_birth
							? new Date(spouseDetails.date_of_birth)
							: new Date(),
						gender: spouseDetails?.gender,
						percentage: 100,
						phone_number: spouseDetails.phone_number,
						canEdit: false
					};
					setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
					setSelectCard("member-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "spouse-card-spouse" || eventName === "spouse-card-estate") {
				if ([...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].length === 0) {
					const spouseDetails = dependents.filter((val: any, index: number) => {
						if (val.relationship === "SPOUSE") {
							return true;
						} else {
							return false;
						}
					})[0];
					let newBeneficiary: Beneficiary | null = null;
					if (eventName === "spouse-card-spouse") {
						newBeneficiary = {
							first_name: member?.first_name,
							last_name: member?.last_name,
							type: "PRIMARY",
							enrollment_id: member?._id,
							insured_SSN: member?.SSN,
							relation: member?.relationship,
							address_line_1: member?.address_line_1,
							address_line_2: member?.address_line_2,
							state: member?.state,
							ZIP: member?.ZIP,
							SSN: member?.SSN,
							date_of_birth: member?.date_of_birth ? new Date(member.date_of_birth) : new Date(),
							gender: member?.gender,
							percentage: 100,
							phone_number: member.phone_number,
							canEdit: false
						};
					} else {
						newBeneficiary = {
							first_name: spouseDetails?.first_name,
							last_name: spouseDetails?.last_name,
							type: "PRIMARY",
							enrollment_id: spouseDetails?._id,
							insured_SSN: spouseDetails?.SSN,
							relation: spouseDetails?.relationship,
							address_line_1: spouseDetails?.address_line_1,
							address_line_2: spouseDetails?.address_line_2,
							state: spouseDetails?.state,
							ZIP: spouseDetails?.ZIP,
							SSN: spouseDetails?.SSN,
							date_of_birth: spouseDetails?.date_of_birth
								? new Date(spouseDetails.date_of_birth)
								: new Date(),
							gender: spouseDetails?.gender,
							percentage: 100,
							phone_number: spouseDetails.phone_number,
							canEdit: false
						};
					}
					setAddSpousePrimaryBeneficiary([...addSpousePrimaryBeneficiary, newBeneficiary]);
					setSelectCard("spouse-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "member-card-add-beneficiary") {
				setSelectCard("member-card");
				setModalOpen(true);
			} else if (eventName === "spouse-card-add-beneficiary") {
				setSelectCard("spouse-card");
				setModalOpen(true);
			} else if (eventName === "save-beneficiary") {
				if (selectCard === "member-card") {
					if (
						(primaryMemberBeneficiary.percentage +
							contingentMemberBeneficiary.percentage +
							parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
							200 &&
							(beneficiaryAllDetails.type === "PRIMARY"
								? primaryMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100
								: contingentMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100)) ||
						editData !== null
					) {
						if (editData !== null) {
							const editedMemberPrimaryBeneficiary = addMemberPrimaryBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberPrimaryBeneficiary(editedMemberPrimaryBeneficiary);
							const editedMemberContingentBeneficiary = addMemberContigentBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberContigentBeneficiary(editedMemberContingentBeneficiary);
							setEditData(null);
						} else {
							if (beneficiaryAllDetails.type === "PRIMARY") {
								const newBeneficiary: Beneficiary = {
									first_name: beneficiaryAllDetails?.firstName,
									last_name: beneficiaryAllDetails?.lastName,
									type: beneficiaryAllDetails.type,
									enrollment_id: beneficiaryAllDetails?._id,
									insured_SSN: beneficiaryAllDetails?.ssn,
									relation: beneficiaryAllDetails?.relationship,
									address_line_1: beneficiaryAllDetails?.address,
									address_line_2: beneficiaryAllDetails?.address2,
									state: beneficiaryAllDetails?.state,
									ZIP: beneficiaryAllDetails?.zipCode,
									SSN: beneficiaryAllDetails?.ssn,
									date_of_birth:
										beneficiaryAllDetails.dob !== ""
											? new Date(beneficiaryAllDetails.date_of_birth)
											: new Date(),
									gender: beneficiaryAllDetails?.gender,
									percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
									phone_number: beneficiaryAllDetails.telephone,
									canEdit: true
								};
								setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
							} else {
								if (editData !== null) {
									const editedMemberContigentBeneficiary = addMemberContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddMemberContigentBeneficiary(editedMemberContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddMemberContigentBeneficiary([
										...addMemberContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						}
					} else {
						alert("Percentage should be less tha 100. Please delete any beneficiary");
						setModalOpen(false);
					}
				} else {
					if (editData !== null) {
						const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
						const editedSpouseContingentBeneficiary = addSpouseContigentBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpouseContigentBeneficiary(editedSpouseContingentBeneficiary);
						setEditData(null);
					} else {
						if (
							(primarySpouseBeneficiary.percentage +
								contingentSpouseBeneficiary.percentage +
								parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								200 &&
								(beneficiaryAllDetails.type === "PRIMARY"
									? primarySpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100
									: contingentSpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100)) ||
							editData !== null
						) {
							if (beneficiaryAllDetails.type === "PRIMARY") {
								if (editData !== null) {
									const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpousePrimaryBeneficiary([...addSpousePrimaryBeneficiary, newBeneficiary]);
								}
							} else {
								if (editData !== null) {
									const editedSpouseContigentBeneficiary = addSpouseContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpouseContigentBeneficiary(editedSpouseContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpouseContigentBeneficiary([
										...addSpouseContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						} else {
							alert("Percentage should be less tha 100. Please delete any beneficiary");
							setModalOpen(false);
						}
					}
				}
				setModalOpen(false);
			} else {
				setModalOpen(false);
			}
			// const { name, checked } = event.target;
			// if (name === "member-death-chronic-illness") {
			// 	setHasMemberAccidentalDeath(checked);
			// } else {
			// 	setHasSpouseAccidentalDeath(checked);
			// }
		},
		[
			member,
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			dependents,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary,
			selectCard,
			primaryMemberBeneficiary.percentage,
			contingentMemberBeneficiary.percentage,
			editData,
			primarySpouseBeneficiary.percentage,
			contingentSpouseBeneficiary.percentage
		]
	);
	const handleEdit = useCallback((data: Beneficiary, cardId: string) => {
		setSelectCard(cardId);
		setEditData(data);
		setModalOpen(true);
	}, []);
	const handleDelete = useCallback(
		(data: Beneficiary, cardId: string) => {
			setSelectCard(cardId);
			if (cardId === "member-card" && data.type === "PRIMARY") {
				setAddMemberPrimaryBeneficiary(
					addMemberPrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "member-card" && data.type === "CONTINGENT") {
				setAddMemberContigentBeneficiary(
					addMemberContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "spouse-card" && data.type === "CONTINGENT") {
				setAddSpouseContigentBeneficiary(
					addSpouseContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else {
				setAddSpousePrimaryBeneficiary(
					addSpousePrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			}
		},
		[
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary
		]
	);

	const handlePlanInputChange = useCallback(
		(event: SelectChangeEvent<unknown>, child: React.ReactNode) => {
			const { name, value } = event.target;
			setCriticalIllnessPlanInputs(
				Object.assign({}, criticalIllnessPlanInputs, {
					[name]: value
				})
			);
		},
		[criticalIllnessPlanInputs]
	);

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const calculatePremium = useCallback(() => {
		const { coverage, coverage_level, benefit_amount } = criticalIllnessPlanInputs;
		if (
			paycheck !== null &&
			coverage !== null &&
			coverage_level !== null &&
			coverage_level !== null &&
			benefit_amount !== null &&
			member?.date_of_birth
		) {
			const ageGroup = calculateAgeGroup(calculateAge(member.date_of_birth as any, new Date()));
			// // console.log(
			// 	"ageGroup",
			// 	coverage,
			// 	VEB_TO_GENERAL_COVERAGE_CODE[coverage as keyof typeof VEB_TO_GENERAL_COVERAGE_CODE],
			// 	CRITICAL_ILLNESS_PREMIUM.premium_amount.standard_premium[
			// 		VEB_TO_GENERAL_COVERAGE_CODE[
			// 			coverage as keyof typeof VEB_TO_GENERAL_COVERAGE_CODE
			// 		] as keyof CriticalIllnessPlanCoverage
			// 	]
			// );
			const _standardPremium =
				CRITICAL_ILLNESS_PREMIUM.premium_amount.standard_premium[coverage as keyof CriticalIllnessPlanCoverage][
					coverage_level as keyof CriticalIllnessCoverageLevel
				][benefit_amount as keyof CriticalIllnessBenefitLevel][ageGroup as keyof CriticalIllnessAgeGroups][
					paycheck.pay_frequency as keyof PaycheckFrequency
				];
			setStandardPremium(_standardPremium);
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Critical Illness",
						status: "Current",
						premium_amount: Number(_standardPremium.toFixed(2))
					}
				)
			);
		}
	}, [criticalIllnessPlanInputs, member.date_of_birth, paycheck, setCurrentEnrollment]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const handleBeneficiaryChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpandedPanel(newExpanded ? panel : false);
	};

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
			generateCriticalIllnessWaiveEnrollmentPayload(
				criticalIllnessPlan,
				VEB_PLAN_NAME.kemper.criticalIllness.standard_critical_illness,
				VEB_PLAN_NAME.kemper.criticalIllness.standard_critical_illness,
				null,
				groupOwner,
				member,
				waiveReason,
				VEBOpenEnrollmentId as unknown as string,
				false
			);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		if (response) {
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
			const step = urlSearchParams.get("step");
			const from = urlSearchParams.get("from");
			if (from === "Cancer") {
				alert("Succesfully waived for Critical Illness plan");
				history.push(`?step=${from}&stage=1`);
			} else {
				history.push(`?step=${step}&stage=2`);
			}
		}
	}, [
		member,
		VEBOpenEnrollment,
		criticalIllnessPlan,
		groupOwner,
		waiveReason,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);

	const handleWaiveButtonClick = useCallback((): void => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleValidation = useCallback((): boolean => {
		const { coverage, coverage_level } = criticalIllnessPlanInputs;
		if (coverage === null || coverage_level === null) {
			alert("Please fill all required fields");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [criticalIllnessPlanInputs, hasReadTC, isActivelyWorking]);

	const waitForModalToClose = () =>
		//eslint-disable-next-line
		new Promise<void>((resolve) => {
			const checkModal = () => {
				if (!isDependentExistsModelOpenRef.current) {
					resolve();
				} else {
					setTimeout(checkModal, 1000);
				}
			};
			checkModal();
		});

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		// console.log("isValid", isValid);
		// console.log("criticalIllnessPlan", criticalIllnessPlan);
		if (isValid === false) {
			return;
		}
		if (
			member &&
			criticalIllnessPlanInputs.coverage &&
			criticalIllnessPlanInputs.benefit_amount &&
			criticalIllnessPlan &&
			VEBOpenEnrollment &&
			paycheck
		) {
			// console.log("criticalIllnessPlanInputs", criticalIllnessPlanInputs);
			const VEBEnrollments: VEBEnrollments[] = [
				{
					plan: criticalIllnessPlan,
					premiumAmount: standardPremium,
					totalPremium: standardPremium,
					coverageCode:
						VEB_TO_GENERAL_COVERAGE_CODE[
							criticalIllnessPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType
						],
					benefitAmount: criticalIllnessPlanInputs.benefit_amount,
					planName: "Critical Illness",
					subPlan: criticalIllnessPlanInputs.coverage_level
				}
			];

			// console.log("VEBEnrollments", VEBEnrollments);
			const enrollmentSuccessFlag = true;
			const activateEnrollmentPromises: any[] = [];
			let standardPayload: any;
			VEBEnrollments.forEach(async (VEBEnrollment: VEBEnrollments) => {
				const { plan, premiumAmount, totalPremium, coverageCode, benefitAmount, planName, subPlan } =
					VEBEnrollment;
				const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
					generateActivateVEBEnrollmentPayload(
						plan,
						groupOwner,
						member,
						benefitAmount,
						coverageCode,
						premiumAmount,
						eligibleDependents,
						planName,
						totalPremium,
						"Critical Illness",
						subPlan,
						VEBOpenEnrollmentId as unknown as string,
						paycheck,
						writingNumber
					);
				const updatedVEBEnrollmentStandardDetails = VEBEnrollmentStandardDetails.map(
					(VEBEnrollmentStandardDetail: VEBEnrollmentStandardDetails) => {
						if (VEBEnrollmentStandardDetail.member_SSN === VEBEnrollmentCommonDetails.insured_SSN) {
							return {
								...VEBEnrollmentStandardDetail,
								VEB_primary_beneficiary: BV2employeePrimaryBeneficiary,
								VEB_contingent_beneficiary: BV2employeeContingentBeneficiary
							};
						} else if (VEBEnrollmentStandardDetail.member_SSN === spouse?.SSN) {
							return {
								...VEBEnrollmentStandardDetail,
								VEB_primary_beneficiary: BV2spousePrimaryBeneficiary,
								VEB_contingent_beneficiary: BV2spouseContingentBeneficiary
							};
						} else {
							return {
								...VEBEnrollmentStandardDetail,
								VEB_primary_beneficiary: [],
								VEB_contingent_beneficiary: []
							};
						}
					}
				);
				const VEBEnrollmentPayload: VEBEnrollmentPayload = {
					standard_details: updatedVEBEnrollmentStandardDetails,
					common_details: VEBEnrollmentCommonDetails,
					isRider: false
				};
				if (!standardPayload) {
					standardPayload = VEBEnrollmentPayload;
				}
				// activateEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
			});
			const existEnrollmentData = await trackPromise(api.enrollment.existsVEBEnrollment(standardPayload));
			// console.log("CHECKIMGFORTHIOSHIOT----->", existEnrollmentData);
			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				setIsDependentExistsModelOpen(true);
				// setExistsDependentData(existEnrollmentData[0].member);
				//eslint-disable-next-line
				setExistsDependentData(existEnrollmentData.map((item) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();
			} else {
				setExistsDependentData(null); // Handle empty case
			}
			if (existEnrollmentData && Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNs = existEnrollmentData
					//eslint-disable-next-line
					.map((enrollment) => enrollment?.member?.SSN)
					//eslint-disable-next-line
					.filter((ssn) => ssn); // Filter out undefined or null SSNs

				if (existingSSNs.length > 0 && standardPayload.standard_details) {
					standardPayload.standard_details = standardPayload.standard_details.filter(
						(detail: any) => !existingSSNs.includes(detail.member_SSN) && !detail.member_SSN.includes("@")
					);
				}
			}
			// const response = await trackPromise(Promise.all(activateEnrollmentPromises));
			if (standardPayload.standard_details && standardPayload.standard_details.length === 1) {
				const { coverage, coverage_level, benefit_amount } = criticalIllnessPlanInputs;
				const ageGroup = calculateAgeGroup(calculateAge(member.date_of_birth as any, new Date()));
				const employeeOnlyPremium =
					CRITICAL_ILLNESS_PREMIUM.premium_amount.standard_premium["Employee Only"][
						coverage_level as keyof CriticalIllnessCoverageLevel
					][benefit_amount as keyof CriticalIllnessBenefitLevel][ageGroup as keyof CriticalIllnessAgeGroups][
						paycheck.pay_frequency as keyof PaycheckFrequency
					];

				console.log("CHECKINGTHISSHIT", employeeOnlyPremium);
				const totalPremium = employeeOnlyPremium;

				standardPayload.standard_details[0].premium_amount = totalPremium;
				standardPayload.common_details.total_premium = totalPremium;
			}
			const standardResponse = await trackPromise(api.enrollment.addVEBEnrollment(standardPayload));
			if (standardResponse) {
				deleteCurrentEnrollment();
				getVEBEnrollmentInitData();
				const step = urlSearchParams.get("step");
				const from = urlSearchParams.get("from");
				if (from === "Cancer") {
					alert(`Succesfully enrolled for Critical Illness with ${criticalIllnessPlanInputs.coverage_level}`);
					history.push(`?step=${from}&stage=1`);
				} else {
					history.push(`?step=${step}&stage=2`);
				}
			}
		}
	}, [
		BV2employeeContingentBeneficiary,
		BV2employeePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		BV2spousePrimaryBeneficiary,
		VEBOpenEnrollment,
		criticalIllnessPlan,
		criticalIllnessPlanInputs,
		deleteCurrentEnrollment,
		eligibleDependents,
		getVEBEnrollmentInitData,
		groupOwner,
		handleValidation,
		history,
		member,
		paycheck,
		spouse?.SSN,
		standardPremium,
		urlSearchParams,
		writingNumber
	]);

	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const getCancerEnrollment = useCallback(async () => {
		const cancerEnrollment: VEBEnrollmentSchema | null = await trackPromise(api.enrollment.getCancerEnrollment());
		if (cancerEnrollment) {
			setHasCancerEnrollment(true);
			setEnrollmentDependencyDialogProps(
				Object.assign({}, enrollmentDependencyDialogProps, { openDialog: true })
			);
			// alert(
			// 	"You are ineligible for Critical Illness With Cancer Plan Coverage level since you have already enrolled for Cancer Plan!!\n\nIf you want to enroll for Critical Illness With Cancer coverage level please waive Cancer Plan"
			// );
		} else {
			setHasCancerEnrollment(false);
			setCriticalIllnessPlanDetails((prevCriticalIllnessPlanDetails: CriticalIllnessPlanDetails) => {
				return Object.assign({}, prevCriticalIllnessPlanDetails, {
					coverage_level: ["With Cancer", ...prevCriticalIllnessPlanDetails.coverage_level]
				});
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClose = () => {
		setModalOpen(false);
		setEditData(null);
	};

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleOpenDisclaimerDialogClick = useCallback(
		(event: React.MouseEvent<HTMLSpanElement>) => {
			setEnrollmentDisclaimerDialogProps(
				Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true })
			);
		},
		[enrollmentDisclaimerDialogProps]
	);

	useEffect(() => {
		calculatePremium();
	}, [
		calculatePremium,
		criticalIllnessPlanInputs.coverage,
		criticalIllnessPlanInputs.coverage_level,
		criticalIllnessPlanInputs.benefit_amount
	]);

	useEffect(() => {
		getCancerEnrollment();
		const dependentCoverage = getKemperCriticalIllnessEligibleDependents(dependents);

		setEligibleDependents(Object.assign([], dependentCoverage.dependents));
		setCriticalIllnessPlanDetails((prevCancerPlanDetails: CriticalIllnessPlanDetails) => {
			return Object.assign({}, prevCancerPlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		const _spouse = dependentCoverage.dependents.find((dependent: Member) => dependent.relationship === "SPOUSE");
		if (_spouse) {
			setSpouse(Object.assign({}, _spouse));
		}
		setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
			return Object.assign({}, prevEligiblityDialogProps, {
				openDialog: true,
				eligibleDependents: Object.assign([], dependentCoverage.dependents),
				ineligibleRelationshipDependents: Object.assign([], dependentCoverage.ineligibleRelationshipDependents),
				ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
			});
		});
		setEligiblity(
			Object.assign(
				{},
				{
					eligibleDependents: Object.assign([], dependentCoverage.dependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				}
			)
		);
	}, [dependents, getCancerEnrollment, setEligiblity]);

	// useEffect(() => {
	// 	let primaryMemberBeneficiaryCount = 0;
	// 	let primaryMemberBeneficiaryPercentage = 0;
	// 	let primarySpouseBeneficiaryCount = 0;
	// 	let primarySpouseBeneficiaryPercentage = 0;
	// 	let contingentMemberBeneficiaryCount = 0;
	// 	let contingentMemberBeneficiaryPercentage = 0;
	// 	let contingentSpouserBeneficiaryCount = 0;
	// 	let contingentSpouseBeneficiaryPercentage = 0;
	// 	if (selectCard === "member-card") {
	// 		[...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].forEach(
	// 			(element: Beneficiary, index: number) => {
	// 				if (element.type === "PRIMARY") {
	// 					primaryMemberBeneficiaryPercentage = primaryMemberBeneficiaryPercentage + element.percentage;
	// 					primaryMemberBeneficiaryCount = primaryMemberBeneficiaryCount + 1;
	// 				}
	// 				if (element.type === "CONTINGENT") {
	// 					contingentMemberBeneficiaryCount = contingentMemberBeneficiaryCount + 1;
	// 					contingentMemberBeneficiaryPercentage =
	// 						contingentMemberBeneficiaryPercentage + element.percentage;
	// 				}
	// 			}
	// 		);
	// 		setPrimaryMemberBeneficiary(
	// 			Object.assign({}, primaryMemberBeneficiary, {
	// 				percentage: primaryMemberBeneficiaryPercentage,
	// 				count: primaryMemberBeneficiaryCount
	// 			})
	// 		);
	// 		setContingentMemberBeneficiary(
	// 			Object.assign({}, contingentMemberBeneficiary, {
	// 				percentage: contingentMemberBeneficiaryPercentage,
	// 				count: contingentMemberBeneficiaryCount
	// 			})
	// 		);
	// 	} else {
	// 		if (selectCard === "spouse-card") {
	// 			[...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].forEach(
	// 				(element: Beneficiary, index: number) => {
	// 					if (element.type === "PRIMARY") {
	// 						primarySpouseBeneficiaryPercentage =
	// 							primarySpouseBeneficiaryPercentage + element.percentage;
	// 						primarySpouseBeneficiaryCount = primarySpouseBeneficiaryCount + 1;
	// 					}
	// 					if (element.type === "CONTINGENT") {
	// 						contingentSpouseBeneficiaryPercentage =
	// 							contingentSpouseBeneficiaryPercentage + element.percentage;
	// 						contingentSpouserBeneficiaryCount = contingentSpouserBeneficiaryCount + 1;
	// 					}
	// 				}
	// 			);
	// 			setPrimarySpouseBeneficiary(
	// 				Object.assign({}, primarySpouseBeneficiary, {
	// 					percentage: primarySpouseBeneficiaryPercentage,
	// 					count: primarySpouseBeneficiaryCount
	// 				})
	// 			);
	// 			setContingentSpouseBeneficiary(
	// 				Object.assign({}, contingentSpouseBeneficiary, {
	// 					percentage: contingentSpouseBeneficiaryPercentage,
	// 					count: contingentSpouserBeneficiaryCount
	// 				})
	// 			);
	// 		}
	// 	}
	// }, [
	// 	addSpousePrimaryBeneficiary,
	// 	addSpouseContigentBeneficiary,
	// 	addMemberPrimaryBeneficiary,
	// 	addMemberContigentBeneficiary,
	// 	selectCard
	// ]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	return (
		<>
			<Suspense fallback={<div />}>
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<EnrollmentDependencyDialog dialogProps={enrollmentDependencyDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<CustomEnrollmentDisclaimerDialog
					enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
					handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
					handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
					emailDisclaimer={emailDisclaimer}
					setEmailDisclaimer={setEmailDisclaimer}
				/>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="kemper-cancer-form plan-form">
					<div className="paper-form-container">
						<Paper className="theme-border-radius paper-container" elevation={1}>
							<VEBPlanHeader
								planName="MedMutual Protect Group Critical Illness Insurance Policy"
								effectiveDate={
									planCode
										? planCode === "CI-ALL-2024"
											? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
											: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
										: "N/A"
								}
								planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
							/>
							<div className="plan-content">
								<div className="theme-plan-section-margin" />
								<div className="header-container">
									<div className="theme-plan-header">Standard Benefits</div>
									<div
										className="theme-plan-sub-header plan-text"
										style={{ borderLeftColor: theme.primary_color }}
									>
										In addition to yourself, who would you like to cover under this plan?
									</div>
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage Level</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="coverage_level"
												onChange={handlePlanInputChange}
											>
												{criticalIllnessPlanDetails.coverage_level.map(
													(coverage_level: string, index: number) => {
														return (
															<MenuItem value={coverage_level} key={index}>
																{coverage_level}
															</MenuItem>
														);
													}
												)}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Coverage For</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="coverage"
												onChange={handlePlanInputChange}
											>
												{criticalIllnessPlanDetails.coverage.map(
													(coverage: string, index: number) => {
														return (
															<MenuItem value={coverage} key={index}>
																{coverage}
															</MenuItem>
														);
													}
												)}
											</Select>
										</div>
									</Grid>
									<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
										<div className="details-form-row">
											<div className="details-form-label  required">Benefit Amount</div>
											<Select
												input={<CustomSelectInput />}
												style={{ width: "100%" }}
												name="benefit_amount"
												onChange={handlePlanInputChange}
											>
												{criticalIllnessPlanDetails.benefit_amount.map(
													(amount: number, index: number) => {
														return (
															<MenuItem key={index} value={amount}>
																{dollarize(amount)}
															</MenuItem>
														);
													}
												)}
											</Select>
										</div>
									</Grid>
									<Grid item xl={2} lg={2} md={2} sm={2} xs={6} className="amount-middle">
										<div className="details-form-row">
											<div className="details-form-label required align-center">Premium</div>
											<div className="show-premium">{dollarize(standardPremium)}</div>
										</div>
									</Grid>
								</Grid>
								<div className="theme-plan-inner-section-margin" />
								<Grid container className="theme-plan-inner-section-margin">
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<div className="details-form-row">
											<div
												className="details-form-label theme-plan-total-premium align-right"
												style={{ color: theme.primary_color }}
											>
												Total Premium:{" "}
												<span className="show-premium margin-adjust">
													{dollarize(standardPremium)}
												</span>
											</div>
										</div>
									</Grid>
								</Grid>
							</div>

							{/* <div className="accordion-container">
								<Accordion
									expanded={expanded_panel === "panel_beneficiary"}
									onChange={handleBeneficiaryChange("panel_beneficiary")}
								>
									<AccordionSummary aria-controls="panel1d-content" id="panel-header-beneficiary">
										<Typography>Add Beneficiary</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Grid
											container
											justifyContent={"center"}
											justifyItems="center"
											alignItems={"center"}
										>
											{member &&
											(criticalIllnessPlanInputs.coverage === "Employee Only" ||
												criticalIllnessPlanInputs.coverage === "Employee & Children" ||
												criticalIllnessPlanInputs.coverage === "Employee & Spouse" ||
												criticalIllnessPlanInputs.coverage === "Employee & Family") ? (
												<Grid item xl={12} lg={12} md={12}>
													<VEBBeneficiary
														primaryBeneficiary={BV2employeePrimaryBeneficiary}
														setPrimaryBeneficiary={setBV2EmployeePrimaryBeneficiary}
														contingentBeneficiary={BV2employeeContingentBeneficiary}
														setContingentBeneficiary={setBV2EmployeeContingentBeneficiary}
														member={member}
														employee={member}
														dependents={dependents}
													/>
												</Grid>
											) : null}
											{spouse &&
											(criticalIllnessPlanInputs.coverage === "Employee & Spouse" ||
												criticalIllnessPlanInputs.coverage === "Spouse Only" ||
												criticalIllnessPlanInputs.coverage === "Spouse & Children" ||
												criticalIllnessPlanInputs.coverage === "Employee & Family") ? (
												<Grid item xl={12} lg={12} md={12}>
													<div className="theme-plan-section-margin" />
													<VEBBeneficiary
														primaryBeneficiary={BV2spousePrimaryBeneficiary}
														setPrimaryBeneficiary={setBV2SpousePrimaryBeneficiary}
														contingentBeneficiary={BV2spouseContingentBeneficiary}
														setContingentBeneficiary={setBV2SpouseContingentBeneficiary}
														member={spouse}
														employee={member}
														dependents={dependents}
													/>
												</Grid>
											) : null}
										</Grid>
									</AccordionDetails>
									<AccordionDetails>
										<Grid container className="card-grid-container">
											{criticalIllnessPlanInputs.coverage === "Employee Only" &&
											criticalIllnessPlanInputs.coverage_level !== null &&
											criticalIllnessPlanInputs.benefit_amount !== null ? (
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="member-card"
														addBeneficiaryDetails={[
															...addMemberPrimaryBeneficiary,
															...addMemberContigentBeneficiary
														]}
														memberName={member.first_name}
														primaryBeneficiaryCount={primaryMemberBeneficiary.count}
														contingentBeneficiaryCount={contingentMemberBeneficiary.count}
														primaryBeneficiaryPercentage={
															primaryMemberBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentMemberBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
											) : criticalIllnessPlanInputs.coverage === "Employee & Spouse" &&
											  criticalIllnessPlanInputs.coverage_level !== null &&
											  criticalIllnessPlanInputs.benefit_amount !== null ? (
												<>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
														<VEBPlanCard
															handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
															cardId="member-card"
															addBeneficiaryDetails={[
																...addMemberPrimaryBeneficiary,
																...addMemberContigentBeneficiary
															]}
															memberName={member.first_name}
															primaryBeneficiaryCount={primaryMemberBeneficiary.count}
															contingentBeneficiaryCount={
																contingentMemberBeneficiary.count
															}
															primaryBeneficiaryPercentage={
																primaryMemberBeneficiary.percentage
															}
															contingentBeneficiaryPercentage={
																contingentMemberBeneficiary.percentage
															}
															handleEdit={handleEdit}
															handleDelete={handleDelete}
														></VEBPlanCard>
													</Grid>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
														<VEBPlanCard
															handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
															cardId="spouse-card"
															addBeneficiaryDetails={[
																...addSpousePrimaryBeneficiary,
																...addSpouseContigentBeneficiary
															]}
															memberName={spouse === null ? "" : spouse.first_name}
															primaryBeneficiaryCount={primarySpouseBeneficiary.count}
															contingentBeneficiaryCount={
																contingentSpouseBeneficiary.count
															}
															primaryBeneficiaryPercentage={
																primarySpouseBeneficiary.percentage
															}
															contingentBeneficiaryPercentage={
																contingentSpouseBeneficiary.percentage
															}
															handleEdit={handleEdit}
															handleDelete={handleDelete}
														></VEBPlanCard>
													</Grid>
												</>
											) : null}
										</Grid>
									</AccordionDetails>
								</Accordion>
							</div> */}
							{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
								<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
							) : null}
							<div className="theme-plan-option-content">
								<Checkbox
									checked={isActivelyWorking}
									style={{ paddingLeft: 0 }}
									onChange={handleIsActivelyWorkingCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>Are you actively at work 20 or more hours per week?</strong>
								</p>
							</div>
							<div>
								<div className="theme-plan-option-content">
									<Checkbox
										checked={hasReadTC}
										style={{ paddingLeft: 0 }}
										onChange={handleAgreedTCCheckboxChange}
									/>
									<p className="theme-plan-checkbox-label">
										<strong>
											I have read the{" "}
											<span
												className="veb-plan-disclaimer"
												style={{ color: theme.primary_color }}
												onClick={handleOpenDisclaimerDialogClick}
											>
												Disclaimer
											</span>
										</strong>
									</p>
								</div>
							</div>
							{/* <div className="theme-plan-inner-section-margin-2" />
							<Grid container>
								<Grid item xl={4} lg={4} md={4} sm={4} xs={10} columnSpacing={2}>
									<div className="details-form-row">
										<div className="details-form-label required">Writing Number</div>
										<Grid container>
											<Grid item xl={9}>
												<CustomInput
													value={writingNumber}
													onChange={handleWritingNumberChange}
												/>
											</Grid>
											{showWritingNumberValidateButton ? (
												<Grid item xl={3}>
													<div className="writing-number-validate-container">
														<Button
															style={{
																backgroundColor: theme.button.background_color,
																color: theme.button.color,
																opacity: 0.8
															}}
														>
															Validate
														</Button>
													</div>
												</Grid>
											) : null}
										</Grid>
									</div>
								</Grid>
							</Grid> */}
							<div className="theme-plan-inner-section-margin-2" />
							<LazyPlanActions
								waiveButtonCallback={handleWaiveButtonClick}
								activateButtonCallback={handleActivateButtonClick}
							/>
						</Paper>
					</div>
				</div>
				<VEBModal
					open={modalOpen}
					familyDetails={
						selectCard === "member-card"
							? [member, ...dependents].filter((mem: Member, index: number) => {
									return ![...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].some(
										(val: any, index: number) => val.enrollment_id === mem._id
									);
							  })
							: [member, ...dependents].filter((mem: Member, index: number) => {
									return ![...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].some(
										(val: any, index: number) => val.enrollment_id === mem._id
									);
							  })
					}
					data={editData}
					handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
					handleClose={handleClose}
				></VEBModal>
			</Suspense>
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default KemperCriticalIllnessForm;
